import { useState, useEffect } from "react";
import { Modal, Button, Input, Alert } from "antd";

const { TextArea } = Input;

const CancelRenewalModal = ({ open, onCancel, onConfirm, loading = false }) => {
  const [reason, setReason] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    if (!open) {
      setReason("");
      setError("");
    }
  }, [open]);

  const handleOk = () => {
    const trimmed = reason.trim();
    if (!trimmed) {
      setError("Please provide a brief reason for cancellation.");
      return;
    }
    onConfirm(trimmed);
  };

  return (
    <Modal
      open={open}
      onCancel={onCancel}
      title="Cancel Renewal"
      destroyOnClose
      footer={[
        <Button key="cancel" onClick={onCancel} disabled={loading}>
          Back
        </Button>,
        <Button
          key="confirm"
          type="primary"
          danger
          loading={loading}
          onClick={handleOk}
        >
          Confirm Cancel
        </Button>,
      ]}
    >
      <Alert
        type="info"
        showIcon
        style={{ marginBottom: 12 }}
        message="This will mark the renewal as cancelled until you restore it."
        // description=""
      />
      Please provide a reason below:
      <TextArea
        autoSize={{ minRows: 4 }}
        maxLength={1000}
        value={reason}
        onChange={(e) => {
          setReason(e.target.value);
          if (error) setError("");
        }}
        placeholder="e.g., Client does not wish to renew; switching carriers; duplicate submission; etc."
      />
      {error ? (
        <div style={{ color: "#ff4d4f", marginTop: 8 }}>{error}</div>
      ) : null}
    </Modal>
  );
};

export default CancelRenewalModal;
